const buildDispatchData = (actionType: string, data = null as any) => {
  return {
    type: actionType,
    data
  }
}

export {
  buildDispatchData
}